import { render, staticRenderFns } from "./RequestUnlockOTP.vue?vue&type=template&id=1a25e0a8&"
import script from "./RequestUnlockOTP.vue?vue&type=script&lang=ts&"
export * from "./RequestUnlockOTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VProgressCircular,VTooltip})
